import { React, classNames } from '@digsup/core-ui';
import PropTypes from 'prop-types';
import { Text } from '@digsup/components-text';
import { PolaroidCard } from '@digsup/components-polaroid-card';
import { styles } from './TestimonialsItem.scss';

const cx = classNames.bind(styles);

export const TestimonialsItem = ({
  propertyImg,
  propertyLabel,
  authorImg,
  content,
  author,
  ...props
}) => (
  <div className={cx('l-homepage-testimonial')} {...props}>
    <div className="l-homepage-testimonial__media">
      <div className="l-homepage-testimonial__house-thumb">
        <PolaroidCard imgSrc={propertyImg} variant="colorful">
          <PolaroidCard.Title>{propertyLabel}</PolaroidCard.Title>
        </PolaroidCard>
      </div>
      <div className="l-homepage-testimonial__author-thumb">
        <PolaroidCard imgSrc={authorImg} variant="colorful">
          <PolaroidCard.Title>{author}</PolaroidCard.Title>
        </PolaroidCard>
      </div>
    </div>
    <div className="l-homepage-testimonial__content">
      <Text
        size="xs"
        fontFamily="serif"
        className="u-margin-bottom-xlarge-stretched@medium u-padding-right-xxxlarge@xlarge">
        &quot;{content}&quot;
      </Text>
      <Text size="md" align="end" className="l-homepage-testimonial__author">
        - {author}
      </Text>
    </div>
  </div>
);

TestimonialsItem.propTypes = {
  /**
   * Property image src
   */
  propertyImg: PropTypes.string,
  /**
   * Property image label
   */
  propertyLabel: PropTypes.string,
  /**
   * Author image src
   */
  authorImg: PropTypes.string,
  /**
   * Testimonial content
   */
  content: PropTypes.any,
  /**
   * Testimonial author
   */
  author: PropTypes.string,
};

TestimonialsItem.defaultProps = {
  propertyLabel: 'My Dream Home!',
};
